import { render } from "./TranslationsInput.vue?vue&type=template&id=032826bc&scoped=true"
import script from "./TranslationsInput.vue?vue&type=script&lang=js"
export * from "./TranslationsInput.vue?vue&type=script&lang=js"

import "./TranslationsInput.vue?vue&type=style&index=0&id=032826bc&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-032826bc"]])

export default __exports__